import axios from "axios";
import {
    API_URL_SOFTWARE_GENERATE_BY_AI,

} from '../constants';

import { API_BASE_URL } from "../constants";

export default class OtherAssetsService {
    static instance;
    resource = `${API_BASE_URL}/other_asset/`;

    constructor() { }

    static getInstance() {
        if (!OtherAssetsService.instance) {
            OtherAssetsService.instance =
                new OtherAssetsService();
        }

        return OtherAssetsService.instance;
    }

    async list(filters) {
        const response = await axios.get(`${this.resource}list`, {
            params: filters,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async SoftwareFetch() {
        const response = await axios.get(`${this.resource}fetch`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async getCount() {
        const response = await axios.get(`${this.resource}count`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async providers(pageSize, pageIndex, sortOrder, sortField) {
        const response = await axios.get(`${this.resource}providers`, {
            params: {
                pageSize,
                pageIndex,
                sortOrder,
                sortField,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async modules() {
        const response = await axios.get(`${this.resource}modules`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async addModule(payload) {
        const response = await axios.post(`${this.resource}add_module`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async removeModule(payload) {
        const response = await axios.post(`${this.resource}remove_module`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }

    async operatingSystems(pageSize, pageIndex, sortOrder, sortField) {
        const response = await axios.get(`${this.resource}operating_systems`, {
            params: {
                pageSize,
                pageIndex,
                sortOrder,
                sortField,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async types(pageSize, pageIndex, sortOrder, sortField) {
        const response = await axios.get(`${this.resource}types`, {
            params: {
                pageSize,
                pageIndex,
                sortOrder,
                sortField,
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async create(items) {
        const response = await axios.post(`${this.resource}create`, items, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async generateByAI(items) {

        const response = await axios.post(`${API_URL_SOFTWARE_GENERATE_BY_AI}`, items, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                Accept: "application/json",
            },
        });

        return response?.data?.message;
    }

    async downloadCSV() {
        const response = await axios.get(`${this.resource}download`, {
            maxBodyLength: Infinity,
            responseType: "arraybuffer",
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async downloadTemplate() {
        const response = await axios.get(`${this.resource}download_csv_template`, {
            maxBodyLength: Infinity,
            responseType: "arraybuffer",
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async changeStatus(data) {
        const response = await axios.put(`${this.resource}change_status`, {
            other_asset_id: data?.other_asset_id || data?.softwareId,
            status: data?.status,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async changeAssignedAnalyst(data) {
        const response = await axios.put(`${this.resource}change_analyst`, {
            other_asset_id: data?.other_asset_id || data?.softwareId,
            analystId: data?.analystId,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
        return response.data.data;
    }

    async changePriority(data) {
        const response = await axios.put(`${this.resource}change_priority`, {
            other_asset_id: data?.other_asset_id || data?.softwareId,
            priority: data?.priority,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async AddEntity(data) {
        const response = await axios.post(`${this.resource}${data?.assetId}/add_legal_entity`, {
            legal_entity_id: data?.legalEntity,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response.data.data;
    }

    async RemoveEntity(data) {
        const response = await axios.post(`${this.resource}${data?.assetId}/remove_legal_entity`, {
            legal_entity_id: data?.legalEntity,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });

        return response.data.data;
    }

    async details(otherAssetId) {
        const response = await axios.get(`${this.resource}${otherAssetId}/show`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async updateDetails(otherAssetId, payload) {
        const response = await axios.put(
            `${this.resource}${otherAssetId}/edit`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async uploadCSV(formData) {
        const response = await axios.post(`${this.resource}upload_csv`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async delete(id, reason, erasedBy, erasedAt) {
        if (!id) {
            return;
        }

        const data = {
            reason: reason,
            erasedBy: erasedBy,
            erasedAt: erasedAt,
        };
        const response = await axios.delete(`${this.resource}${id}/delete`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
            data,
        });

        return response.data.data;
    }

    async filledQuestionnaires(otherAssetId, questionnaireType) {
        const response = await axios.get(
            `${this.resource}${otherAssetId}/questionnaire_type/${questionnaireType}/list`,
            {
                params: {},
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );
        // console.log("RES", response, `${this.resource}${softwareId}/questionnaire_type/${questionnaireType}/list`)
        return response.data.data;
    }

    async toggleFlag(data) {
        const response = await axios.put(`${this.resource}toggle_flag`, {
            other_asset_id: data?.other_asset_id || data?.softwareId,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async changeDepartment(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_responsible_department`,
            { department: payload?.department },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async changePhoneNumber(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_phone_number`,
            { phone_number: payload?.phone_number || payload?.phoneNumber },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async changeNotice(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_notice`,
            { notice: payload?.notice },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async changeEmail(payload) {
        const response = await axios.post(`${this.resource}${payload?.asset}/change_email`, {
            email: payload?.email,
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async changePosition(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_position`,
            { position: payload?.position },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async changeCompany(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_company`,
            { company: payload?.company },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async changeResponsiblePerson(payload) {
        const response = await axios.post(
            `${this.resource}${payload?.asset}/change_responsible_person`,
            { user_id: payload?.user_id },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    // DPA
    async fetchDPADetail(id) {
        const response = await axios.get(`${this.resource}${id}/dpa/detail`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    // Consultation
    async toggleConsultation(id) {
        const response = await axios.post(
            `${this.resource}${id}/dpa/toggle_consultation_required`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    // Reason
    async toggleReason(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/dpa/update_reason`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    // Date
    async updateDate(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/dpa/update_date`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    // Result
    async updateResult(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/dpa/update_result`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    // History Logs
    async fetchLogs(assetId, params = {}) {
        const response = await axios.get(
            `${API_BASE_URL}/logs?otherAssetId=${assetId}`,
            {
                params: {
                    section: "other_asset",
                    ...params,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );
        return response.data.data;
    }

    async fetchLogDetails(logId, params = {}) {
        const response = await axios.get(
            `${API_BASE_URL}/log/${logId}/show`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );
        return response.data.data;
    }

    // Approve Selection
    async approveSelection(payload) {
        const response = await axios.post(`${this.resource}multi_approve`, {
            other_asset_ids: payload?.other_asset_ids || payload?.softwareIds || [],
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async mentionCommentSearch(caseId) {
        const response = await axios.get(
            `${this.resource}${caseId}/mentionCommentSearch`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
                }
            }
        );

        return response.data?.data;
    }

    async toggleActivation(otherAssetId, payload = {}) {
        const response = await axios.post(`${this.resource}${otherAssetId}/toggle_inactive_status`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }


    async getOtherAssets() {
        const response = await axios.get(`${API_BASE_URL}/asset/index?type=other`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async getSoftwareAssets() {
        return this.getOtherAssets();
    }

    async getDataFlows(otherAssetId) {
        const response = await axios.get(`${this.resource}${otherAssetId}/data_flows`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data;
    }

    async createDataFlow(payload) {
        const response = await axios.post(`${this.resource}data_flow/create`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async updateDataFlow(id, payload) {
        const response = await axios.post(`${this.resource}data_flow/${id}/update`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });

        return response.data.data;
    }

    async deleteDataFlow(id) {
        const response = await axios.delete(`${this.resource}data_flow/${id}/delete`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        }, {});

        return response.data.data;
    }
}
